import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 32px 32px;

  > div:first-child {
    height: 160px;
    width: 260px;
    align-self: center;
  }

  @media only screen and (max-width: 768px) {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;
